(function () {
  'use strict';

  function translateAria(value) {
    if (!value) return value;
    if (value === 'Add to cart') return 'Añadir al carrito';
    if (value === 'Next reviews') return 'Reseñas siguientes';
    if (value === 'Previous reviews') return 'Reseñas anteriores';
    if (value === 'Review snippet card') return 'Tarjeta de reseña';
    if (value === 'Review body') return 'Contenido de la reseña';
    if (value === 'Click to view reviews') return 'Haz clic para ver las reseñas';

    var rating = value.match(
      /^Rated ([\d.,]+) out of 5 from ([\d.,]+) reviews?\. Click to view reviews\.$/,
    );
    if (rating) {
      return 'Calificación de ' + rating[1] + ' sobre 5 basada en '
        + rating[2] + ' reseñas. Haz clic para verlas.';
    }

    var addProduct = value.match(/^Add (.+) to cart$/);
    if (addProduct) return 'Añadir ' + addProduct[1] + ' al carrito';

    var selectOption = value.match(/^Select (.+) for (.+)$/);
    if (selectOption) {
      return 'Seleccionar ' + selectOption[1] + ' para ' + selectOption[2];
    }

    return value;
  }

  function translateJudgeMeText(root) {
    var containers = root.querySelectorAll
      ? root.querySelectorAll('[class*="jdgm"]')
      : [];

    containers.forEach(function (container) {
      var walker = document.createTreeWalker(
        container,
        NodeFilter.SHOW_TEXT,
      );
      var node;
      while ((node = walker.nextNode())) {
        var original = node.nodeValue;
        var trimmed = original.trim();
        var replacement = trimmed
          .replace(/^([\d.,]+) reviews?$/, '$1 reseñas')
          .replace(/^Based on ([\d.,]+) reviews?$/, 'Basado en $1 reseñas')
          .replace(/^Customer Reviews$/, 'Reseñas de clientes')
          .replace(/^Write a review$/, 'Escribir una reseña')
          .replace(/^See all reviews$/, 'Ver todas las reseñas');
        if (replacement !== trimmed) {
          node.nodeValue = original.replace(trimmed, replacement);
        }
      }
    });
  }

  function translateReviewBadgeText(root) {
    var badges = [];
    if (root.nodeType === 1 && root.matches('.ap-rb__count')) badges.push(root);
    if (root.querySelectorAll) {
      badges.push.apply(badges, root.querySelectorAll('.ap-rb__count'));
    }
    badges.forEach(function (badge) {
      badge.textContent = badge.textContent.replace(
        /^(\s*)([\d.,]+) reviews?(\s*)$/,
        '$1$2 reseñas$3',
      );
    });
  }

  function localizeReviewLinks(root) {
    var links = [];
    var selector = 'a[href^="/products/"][href*="#judgeme_product_reviews"]';
    if (root.nodeType === 1 && root.matches(selector)) links.push(root);
    if (root.querySelectorAll) {
      links.push.apply(links, root.querySelectorAll(selector));
    }
    links.forEach(function (link) {
      link.setAttribute('href', '/es' + link.getAttribute('href'));
    });
  }

  function localize(root) {
    if (!root || root.nodeType !== 1 && root.nodeType !== 9) return;

    var labeled = [];
    if (root.nodeType === 1 && root.hasAttribute('aria-label')) labeled.push(root);
    if (root.querySelectorAll) {
      labeled.push.apply(labeled, root.querySelectorAll('[aria-label]'));
    }
    labeled.forEach(function (element) {
      var original = element.getAttribute('aria-label');
      var translated = translateAria(original);
      if (translated !== original) element.setAttribute('aria-label', translated);
    });

    translateJudgeMeText(root);
    translateReviewBadgeText(root);
    localizeReviewLinks(root);
  }

  function start() {
    localize(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          localize(mutation.target);
          return;
        }
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) localize(node);
        });
      });
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-label'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
